var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrow = function SvgIconArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-arrow_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M11.998 14.95q-.2 0-.375-.062a.9.9 0 0 1-.325-.213L6.673 10.05a.9.9 0 0 1-.262-.687.98.98 0 0 1 .287-.688.95.95 0 0 1 .7-.275q.426 0 .7.275l3.9 3.9 3.925-3.925a.9.9 0 0 1 .688-.262.98.98 0 0 1 .687.287.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-4.6 4.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063"
  }))));
};
export default SvgIconArrow;